/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Car\CarSelect\CarSelect.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Tuesday April 9th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 9th 2024 11:41:37 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import { useEffect, useMemo, useState } from "react";

type CarSelectProps = {
    item: string;
    updateKey: string;
    optionsList: string[];
    keyTrad: string;
    label?: string;
    disabled: boolean;
    updateFunc: Function;
};

export default function CarSelect(props: CarSelectProps) {
    const [selected, setSelected] = useState(props.item);
    const id = `carSelect-${props.keyTrad}-${Math.random()}`;

    useEffect(() => {
        setSelected(props.item);
    }, [props.item]);

    const handleChange = (event: SelectChangeEvent) => {
        setSelected(event.target.value);
        props.updateFunc(event.target.value, props.item, props.updateKey);
    };

    const buildOpts = () => {
        const rows: JSX.Element[] = [];
        props.optionsList.map(item => rows.push(<MenuItem key={`${item}-${Math.random()}`} value={item.toUpperCase()}>
            {props.keyTrad ? translator.decode(`${props.keyTrad}.${item.toLowerCase()}`): item}
            </MenuItem>)
        );
        return rows;
    };

    const carSelectOpts = useMemo<JSX.Element[]>(
        () => buildOpts(),[props.optionsList]
    );

    return (
        <FormControl sx={{ m: 0, minWidth: 190, backgroundColor: "white"}} size="small">
            <InputLabel id={id}>{props.label}</InputLabel>
            <Select
                disabled={!props.disabled}
                labelId={id}
                id={`CarSelect_${Math.random()}`}
                value={selected}
                label={props.label}
                onChange={handleChange}
            >
                {carSelectOpts}
            </Select>
        </FormControl>
    );
};
